import tour6Gif from '../../../assets/images/tour-images/tour-6.gif';
import tour7Gif from '../../../assets/images/tour-images/tour-7.gif';
import tour8Jpg from '../../../assets/images/tour-images/tour-8.jpg';

export const tourText = {
  workspaceInsights: {
    title: 'Workspace insights',
    description:
      'Workspaces help you stay organised as you grow. Manage content, users, and permissions—all within dedicated environments tailored to your needs.',
    image: tour6Gif,
  },
  userInsights: {
    title: 'User insights',
    description:
      'Understand how your workspace is being used. Track user access, monitor seat allocation, and manage capacity as your team grows.',
    image: tour7Gif,
  },
  courseInsights: {
    title: 'Course insights',
    description:
      'Gain meaningful insights into your courses. Track performance, learner engagement, and participation across your published content.',
    image: tour8Jpg,
  },
};
